import { type FulfillmentFormValues } from './types'

export const formSteps = [
  { title: 'Организация и склад' },
  { title: 'Способы отгрузки' },
  { title: 'Товары и масштаб' },
  { title: 'Прайс услуг' },
  { title: 'Карты и контакты' },
  { title: 'Описание и фото' },
] as const

/**
 * На каком шаге стоит каждое поле. Тип требует перечислить их все: забытое поле иначе не
 * проверялось бы при переходе, а после отправки уводило бы владельца на чужой шаг — с красной
 * плашкой и без единого подсвеченного поля.
 */
const fieldStep: Record<keyof FulfillmentFormValues, number> = {
  name: 0,
  inn: 0,
  locations: 0,
  shipmentTypes: 1,
  fbsArea: 1,
  dbsArea: 1,
  marketplaces: 1,
  deliveryFrequency: 1,
  otherShipmentDescription: 1,
  categoryMode: 2,
  categoryExclusions: 2,
  areaSquareMeters: 2,
  operationStartedYear: 2,
  activeClientCount: 2,
  minimumUnitPriceRubles: 2,
  servicePrices: 3,
  yandexMapsUrl: 4,
  twoGisUrl: 4,
  websiteUrl: 4,
  phone: 4,
  email: 4,
  telegram: 4,
  max: 4,
  description: 5,
}

const formFields = Object.keys(fieldStep) as (keyof FulfillmentFormValues)[]

/** Поля шага: по ним форма проверяет заполнение перед переходом на следующий. */
export const fieldsOfStep = (step: number) => formFields.filter((field) => fieldStep[field] === step)

/** Шаг, на котором стоит поле. Неизвестное поле отправляем на первый шаг: там его точно видно. */
export const stepOfField = (field: string) => fieldStep[field as keyof FulfillmentFormValues] ?? 0
